module.exports = __webpack_public_path__ + "img/fingerprint.cd05b86e.png";